import { combineEpics } from 'redux-observable';
import { fetchAllDriverRoutesEpic } from './driver-routes/fetch-all-driver-routes.epic';

export const combinedDriverEpics = combineEpics(fetchAllDriverRoutesEpic);
